import { render, staticRenderFns } from "./PayRangeScale.vue?vue&type=template&id=13ccd6f5&scoped=true"
import script from "./PayRangeScale.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeScale.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeScale.vue?vue&type=style&index=0&id=13ccd6f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ccd6f5",
  null
  
)

export default component.exports